export default {
      id: "term-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#term",
      toString: function () {
        return this.url;
      }
    }